"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevMode = void 0;
function isDevMode() {
    return process.env.NODE_ENV == 'dev' || process.env.NODE_ENV == 'debug';
}
exports.isDevMode = isDevMode;
